import { render, staticRenderFns } from "./educationHomePage.vue?vue&type=template&id=455bfc0e&scoped=true"
import script from "./educationHomePage.vue?vue&type=script&lang=js"
export * from "./educationHomePage.vue?vue&type=script&lang=js"
import style0 from "./educationHomePage.vue?vue&type=style&index=0&id=455bfc0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455bfc0e",
  null
  
)

export default component.exports